import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as firebase from 'firebase';
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
import '../view/css/NavBar.css';
import { sendMessage1 } from '../model/contact_model/sendMessage1';

const theme = createMuiTheme({
    typography: {
        fontFamily: 'Rubik',
        fontSize: 18,
    },
});


export function ContactUsModalView(props) {

    return (
        <div className="navLink">
            {/*<a variant="base" onClick={handleClickOpen}>Contact</a> */}
            <a variant="base" onClick={props.handleClickOpen}>Contact Us</a>
            {props.sucess &&   <ThemeProvider theme={props.theme}>
                <Dialog open={props.open} onClose={props.handleSuccesclose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Success! Your message "{props.message}" was sent.</DialogTitle>
                    </Dialog> </ThemeProvider>}
            <ThemeProvider theme={props.theme}>
                <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Contact Us</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {props.error && <i>Please enter a message!</i>}
                            
                            
                        </DialogContentText >
                        <form>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Name"
                                type="name"
                                fullWidth
                                onChange={props.inputName}
                                value={props.name}
                            />
                            <TextField
                                margin="dense"
                                id="email"
                                label="Email Address"
                                type="email"
                                fullWidth
                                onChange={props.inputEmail}
                                value={props.email}
                            />
                            <TextField
                                //autoFocus
                                id="outlined-textarea"
                                label="Message"
                                placeholder="Placeholder"
                                multiline
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                onChange={props.inputMessage}
                                value={props.message}
                            />
                        </form>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={props.submit} color="primary">
                            Send
                        </Button>
                        <Button onClick={props.handleClose} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        
        </div>
    );
}


